var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{on:{"click":function($event){return _vm.fcTableToExcel('tblList')}}},[_c('i',{staticClass:"fas fa-file-excel mr-2"}),_c('span',[_vm._v(_vm._s(_vm.$t("ui.export_excel")))])])}
var staticRenderFns = []

export { render, staticRenderFns }